package com.huanshankeji.compose.material.icons

// TODO make it a value class to save some memory when it's supported by Kotlin or just make the Compose UI impl a value class too
actual class Icon(val name: String)
